import { createQueryParams } from 'src/lib/services/api-query-params';

export const requestedAttentionRequests = createQueryParams({
  filters: [
    {
      id: 'requested_attention_at',
      operator: 'is_set',
      value: undefined,
    },
  ],
});

export const recentlyUpdatedRequests = createQueryParams({
  filters: [
    {
      id: 'reviewed_by_editor',
      operator: 'is_not_set',
      value: undefined,
    },
  ],
  sorts: [
    {
      id: 'status_changed_at',
      desc: true,
    },
    {
      id: 'requested_attention_at',
      desc: true,
    },
  ],
});

export const needsReeditRequests = createQueryParams({
  filters: [
    {
      id: 'requested_reedit_at',
      operator: 'is_set',
      value: undefined,
    },
  ],
});

export const approvedRequests = createQueryParams({
  filters: [
    {
      id: 'approved_at',
      operator: 'is_set',
      value: undefined,
    },
  ],
});
